import Swiper from 'swiper';
export default class Landing{
	constructor(){
		console.log('Landing :: init');

		this.imageSwiper = new Swiper('.image-slider', {
		    loop: true,
		    effect: 'fade',
			fadeEffect: {
    			crossFade: true
  			},
		});

		this.contentSwiper = new Swiper('.content-slider', {
		    loop: true,
		    effect: 'fade',
			fadeEffect: {
    			crossFade: true
  			},
		    pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
				formatFractionCurrent: function (number) {
				    return number < 10 ? '0'+number : number;
				},
				formatFractionTotal: function (number) {
				    return number < 10 ? '0'+number : number;
				},
		    },
		    navigation: {
		    	nextEl: '.swiper-button-next',
		    	prevEl: '.swiper-button-prev',
		    },
		});

		this.imageSwiper.controller.control = this.contentSwiper;
	    this.contentSwiper.controller.control = this.imageSwiper;
	}
}